class APIS {
	apis() {
		return {
			AllClientAccountLimit: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/get/account/limits'
			},
			AllAccountLimit: {
				headers: {
					'xt-user-token': null
				},
				method: 'get',
				path: '/account/limits/all'
			},
			AddAccountLimits: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/account/limits'
			},
            updateAccountLimit: {
				headers: {
					'xt-user-token': null
				},
				method: 'put',
				path: '/account/limits'
			},

		};
	}
}

export default new APIS();